export default __webpack_public_path__ + "static/media/Aneomi-4.24a99e05.png";